import type { Middleware } from '@reduxjs/toolkit';
import { createDynamicMiddleware } from '@reduxjs/toolkit';
import type { AppDispatch } from 'redux/create';
import type { IState } from 'redux/state';

export const dynamicMiddleware = createDynamicMiddleware();

export const addAppMiddleware = dynamicMiddleware.addMiddleware as <TState extends IState = IState>(
  ...middlewares: Middleware<any, TState, AppDispatch>[]
) => void;
